import React from "react";
import { useNavigate } from "react-router-dom";

export default function HomeServicesGrid({
  onOpenMariaChat,
  onOpenMeasuresModal,
  pendingDoseCount = 1,
  lowStockCount = 1,
  currentWeight = "64.5kg",
  bloodPressure = "120/80",
  waterAmount = "1.500ml",
}) {
  const navigate = useNavigate();

  const services = [
    {
      id: "routine",
      title: "Doses & Horários",
      sub: "Planejamento e alertas",
      icon: "⏰",
      iconBg: "bg-purple-100",
      iconColor: "text-[#5B38C2]",
      badge: pendingDoseCount > 0 ? `${pendingDoseCount} Pendente` : null,
      badgeColor: "bg-purple-100 text-purple-900 border border-purple-200",
      onClick: () => navigate("/app/routine"),
    },
    {
      id: "medications",
      title: "Estoque & Remédios",
      sub: "Controle de frascos",
      icon: "📦",
      iconBg: "bg-amber-100",
      iconColor: "text-amber-700",
      badge: lowStockCount > 0 ? `${lowStockCount} Atenção` : null,
      badgeColor: "bg-amber-100 text-amber-900 border border-amber-200",
      onClick: () => navigate("/app/medications"),
    },
    {
      id: "evolution",
      title: "Evolução de Peso",
      sub: `-4,2 kg eliminados`,
      icon: "📈",
      iconBg: "bg-emerald-100",
      iconColor: "text-emerald-700",
      badge: currentWeight ? `Atual ${currentWeight}` : null,
      badgeColor: "bg-emerald-100 text-emerald-900 border border-emerald-200",
      onClick: () => navigate("/app/evolution"),
    },
    {
      id: "readings",
      title: "Pressão & Glicemia",
      sub: "Monitore seus sinais",
      icon: "🩺",
      iconBg: "bg-rose-100",
      iconColor: "text-rose-700",
      badge: bloodPressure || "120/80",
      badgeColor: "bg-rose-100 text-rose-900 border border-rose-200",
      onClick: () => navigate("/app/readings"),
    },
    {
      id: "hydration",
      title: "Hidratação",
      sub: "Consumo de água",
      icon: "💧",
      iconBg: "bg-blue-100",
      iconColor: "text-blue-700",
      badge: waterAmount || "1.500ml",
      badgeColor: "bg-blue-100 text-blue-900 border border-blue-200",
      onClick: () => navigate("/app/readings/hydration"),
    },
    {
      id: "measures",
      title: "Medidas & Bio",
      sub: "Cintura, Quadril, IMC",
      icon: "📏",
      iconBg: "bg-indigo-100",
      iconColor: "text-indigo-700",
      badge: "IMC 23.7",
      badgeColor: "bg-indigo-100 text-indigo-900 border border-indigo-200",
      onClick: onOpenMeasuresModal || (() => navigate("/app/profile")),
    },
    {
      id: "diary",
      title: "Diário de Bordo",
      sub: "Sintomas e bem-estar",
      icon: "📖",
      iconBg: "bg-teal-100",
      iconColor: "text-teal-700",
      badge: "Novo Registro",
      badgeColor: "bg-teal-100 text-teal-900 border border-teal-200",
      onClick: () => navigate("/app/diary"),
    },
    {
      id: "mystika",
      title: "Mystika & Foco",
      sub: "Respiração & Cuidado",
      icon: "🔮",
      iconBg: "bg-violet-100",
      iconColor: "text-violet-700",
      badge: "Equilíbrio",
      badgeColor: "bg-violet-100 text-violet-900 border border-violet-200",
      onClick: () => navigate("/app/mystika"),
    },
    {
      id: "maria",
      title: "Conversar MarIA",
      sub: "Assistente Inteligente",
      icon: "💬",
      iconBg: "bg-purple-200",
      iconColor: "text-purple-900",
      badge: "Online",
      badgeColor: "bg-emerald-100 text-emerald-900 border border-emerald-200 font-bold",
      onClick: onOpenMariaChat || (() => navigate("/app/maria-bot")),
    },
  ];

  return (
    <div className="space-y-2.5">
      <div className="flex items-center justify-between px-1">
        <span className="text-xs font-black text-gray-900 tracking-tight uppercase">
          Serviços & Monitoramento
        </span>
        <span className="text-[10px] font-bold text-gray-400">9 áreas</span>
      </div>

      <div className="grid grid-cols-3 gap-2 sm:gap-2.5">
        {services.map((item) => (
          <button
            key={item.id}
            type="button"
            onClick={item.onClick}
            className="group relative flex flex-col items-center text-center p-2.5 sm:p-3 rounded-2xl sm:rounded-3xl bg-white border border-purple-100/80 shadow-xs hover:shadow-md hover:border-purple-300 transition-all duration-200 active:scale-95 cursor-pointer min-h-[118px] justify-between"
          >
            {/* Ícone */}
            <div
              className={`w-10 h-10 rounded-2xl ${item.iconBg} flex items-center justify-center text-lg shadow-2xs group-hover:scale-105 transition-transform flex-shrink-0`}
            >
              {item.icon}
            </div>

            {/* Título & Subtítulo */}
            <div className="w-full my-1">
              <h4 className="text-[11px] font-black text-gray-900 leading-tight line-clamp-1 group-hover:text-[#5B38C2] transition-colors">
                {item.title}
              </h4>
              <p className="text-[9px] font-medium text-gray-500 leading-tight line-clamp-1 mt-0.5">
                {item.sub}
              </p>
            </div>

            {/* Badge de Status */}
            {item.badge && (
              <span
                className={`text-[8.5px] font-extrabold px-1.5 py-0.5 rounded-md ${item.badgeColor} leading-none tracking-tight block max-w-full truncate`}
              >
                {item.badge}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
